import { getGetApiEmbeddingCollectionGetQueryKey, usePostApiEmbeddingAddExcel } from "@/API";
import { Button, ButtonProps, FileButton } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, useRef, useState } from "react";

export function EmbeddingAddExcelButton(props: { workspaceId: string, embeddingCollectionId: string, buttonProps?: ButtonProps } & PropsWithChildren) {
    const queryClient = useQueryClient()
    const resetRef = useRef<() => void>(null);
    const import_Mutation = usePostApiEmbeddingAddExcel()
    const [loading, setLoading] = useState(false)
    return <>
        <FileButton resetRef={resetRef} onChange={async f => {
            resetRef.current?.();
            if (f) {
                setLoading(true)
                try {
                    await import_Mutation.mutateAsync({
                        params: {
                            workspaceId: props.workspaceId,
                            collectionId: props.embeddingCollectionId
                        },
                        data: {
                            file: f
                        }
                    })
                    queryClient.invalidateQueries({
                        queryKey: getGetApiEmbeddingCollectionGetQueryKey({
                            workspaceId: props.workspaceId,
                            id: props.embeddingCollectionId
                        })
                    })
                    notifications.show({ message: "新增成功" })


                } catch (e) {
                    notifications.show({ message: "新增失敗", color: "red" })
                }
                setLoading(false)
            }
        }} accept="text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
            {(_props) => <Button loading={loading} {..._props} {...props.buttonProps}>{props.children}</Button>}
        </FileButton>
    </>
}